const useFormatIntlString = () => {
  const formatIntlString = (string, args) => {
    return string.replace(/{(\d+)}/g, (match, number) => {
      return typeof args[number] !== 'undefined' ? args[number] : match;
    });
  };

  return formatIntlString;
};

export default useFormatIntlString;
